export default "/_next/static/media/enjoei-collectionwidget3-1-1024x348.ddc7420bc54a2a41622421ff1a3372fc.png";